<template>
  <section
    :class="[
      style.leftPart,
      mobileVersion ? styleQuestion.questionMobile : '',
      mobileVersion ? style.mobile : ''
    ]"
    :style="getStyleLeftPart"
    id="scrollChecked"
  >
    <LogoComponent v-if="!mobileVersion" :class="style.logo" />
    <div
      :class="[
        styleQuestion.processBar,
        mobileVersion ? styleQuestion.mobile : ''
      ]"
      v-if="
        (indexQuestion <= quiz.questions.length - 2 && !mobileVersion) ||
        (indexQuestion < quiz.questions.length - 2 && mobileVersion)
      "
    >
      <div
        :style="{
          width: (indexQuestion / (quiz.questions.length - 2)) * 100 + '%'
        }"
      ></div>
      <div></div>
    </div>
    <HeaderContactsComponent
      v-if="mobileVersion && currentQuestion.type === 'contacts'"
    />
    <EditableWrapper
      :class="style.mainBlockLeftPartEditableWrapper"
      typePanel="question"
      :panelIndex="indexQuestion"
      @openPanel="updateIsShowQuestionSettingPanel"
    >
      <div :class="style.mainBlockLeftPart" :style="styleMainBlockLeftPart">
        <ActionComponent
          v-if="
            (currentQuestion.type === 'contacts' ||
              currentQuestion.type === 'ThankYouPages') &&
            !mobileVersion
          "
        />
        <AutoResizeTextArea
          :value="
            currentQuestion.type !== 'contacts'
              ? currentQuestion.question
              : currentQuestion?.contacts?.header
          "
          v-if="!(currentQuestion?.type === 'contacts' && mobileVersion)"
          rows="1"
          @input="setHeaderQuestion"
          :class="style.h2"
          :style="{marginTop: quiz?.actionList?.length > 0 ? '20px' : ''}"
          placeholder="Введите заголовок"
        />
        <AutoResizeTextArea
          :value="currentQuestion?.contacts?.paragraph || ''"
          v-if="!(currentQuestion?.type === 'contacts' && mobileVersion)"
          @input="setParagraphQuestion"
          rows="1"
          placeholder="Введите подзаголовок"
          :class="style.p"
        />

        <div
          :class="[
            styleQuestion.questionBlock,
            mobileVersion ? styleQuestion.mobile : ''
          ]"
          :style="{minHeight: mobileVersion ? '63dvh' : ''}"
        >
          <DropDown v-if="currentQuestion.type === 'select'" />
          <ListAnswers v-else-if="currentQuestion.type === 'radio'" />
          <ListAnswers v-else-if="currentQuestion.type === 'checkbox'" />
          <ListAnswers
            v-else-if="currentQuestion.type === 'radio-img'"
            :withImg="true"
          />
          <ListAnswers
            v-else-if="currentQuestion.type === 'checkbox-img'"
            :withImg="true"
          />
          <InputAnswer v-else-if="currentQuestion.type === 'text'" />
          <InputAnswer v-else-if="currentQuestion.type === 'textArea'" />
          <TeethAnswer v-else-if="currentQuestion.type === 'checkbox-dental'" />
          <InformationAnswer
            v-else-if="currentQuestion.type === 'information'"
          />
          <ContactsAnswer v-else-if="currentQuestion.type === 'contacts'" />
          <ThankYouPageAnswer
            v-else-if="currentQuestion.type === 'ThankYouPages'"
          />
          <ButtonBlockComponent v-if="onlyQuestion" />
        </div>
      </div>
    </EditableWrapper>
  </section>
</template>

<script lang="ts">
import style from "../sections/LeftPart/LeftPart.module.scss";
import styleQuestion from "./QuestionLeftPart.module.scss";
import {defineComponent, CSSProperties} from "vue";
import {modifyQuiz} from "@/page/quiz/scriptQuiz";
import DropDown from "@/page/quiz/editor/landingPage/components/questions/typeQuestions/DropDown/DropDown.vue";
import ListAnswers from "@/page/quiz/editor/landingPage/components/questions/typeQuestions/ListAnswers/ListAnswers.vue";
import InputAnswer from "@/page/quiz/editor/landingPage/components/questions/typeQuestions/InputAnswer/InputAnswer.vue";
import TeethAnswer from "@/page/quiz/editor/landingPage/components/questions/typeQuestions/TeethAnswer/TeethAnswer.vue";
import InformationAnswer from "@/page/quiz/editor/landingPage/components/questions/typeQuestions/InformationAnswer/InformationAnswer.vue";
import ContactsAnswer from "@/page/quiz/editor/landingPage/components/questions/typeQuestions/ContactsAnswer/ContactsAnswer.vue";
import ThankYouPageAnswer from "@/page/quiz/editor/landingPage/components/questions/typeQuestions/ThankYouPageAnswer/ThankYouPageAnswer.vue";
import HeaderContactsComponent from "@/page/quiz/editor/landingPage/components/questions/typeQuestions/ContactsAnswer/components/HeaderContactsComponent/HeaderContactsComponent.vue";
import ButtonBlockComponent from "@/page/quiz/editor/landingPage/components/elements/ButtonBlockComponent/ButtonBlockComponent.vue";
import LogoComponent from "@/page/quiz/editor/landingPage/components/elements/LogoComponent.vue";
import AutoResizeTextArea from "@/elements/autoResizeTextArea/autoResizeTextArea.vue";
import ActionComponent from "@/page/quiz/view/components/sections/components/ActionComponent/ActionComponent.vue";
import {questions, Quiz} from "@/page/quiz/typeQuiz";
import EditableWrapper from "@/page/quiz/editor/landingPage/components/elements/EditableWrapper/EditableWrapper.vue";

export default defineComponent({
  components: {
    EditableWrapper,
    ActionComponent,
    AutoResizeTextArea,
    LogoComponent,
    ButtonBlockComponent,
    HeaderContactsComponent,
    ThankYouPageAnswer,
    ContactsAnswer,
    InformationAnswer,
    TeethAnswer,
    InputAnswer,
    ListAnswers,
    DropDown
  },
  data() {
    return {
      style,
      styleQuestion,
      modifyQuiz
    };
  },
  methods: {
    setHeaderQuestion(event: Event) {
      const target = event.target as HTMLTextAreaElement;
      if (this.currentQuestion.type == "contacts") {
        if (!this.currentQuestion.contacts) {
          this.currentQuestion.contacts = {};
        }

        this.currentQuestion.contacts.header = target.value;
        return;
      }
      this.quiz.questions[this.selectedQuestion].question = target.value;
    },
    setParagraphQuestion(event: Event) {
      const target = event.target as HTMLTextAreaElement;
      if (!this.currentQuestion?.contacts) {
        this.currentQuestion.contacts = {};
      }
      this.currentQuestion.contacts.paragraph = target.value;
    },
    updateIsShowQuestionSettingPanel() {
      this.$panelStore.openSettingPanel({
        name: "question",
        category: this.currentQuestion.type,
        index: this.selectedQuestion
      });
    }
  },
  computed: {
    quiz(): Quiz {
      return this.$quizStore.getQuiz;
    },
    selectedQuestion() {
      return this.$quizStore.getSelectedQuestion;
    },
    currentQuestion(): questions {
      return this.quiz.questions[this.indexQuestion];
    },
    indexQuestion(): number {
      return this.selectedQuestion;
    },
    selectedVersion() {
      return this.$quizStore.getSelectedVersion;
    },
    mobileVersion() {
      return this.selectedVersion === "Мобильная";
    },
    getStyleLeftPart() {
      return {
        height: "100%",
        padding:
          !this.isContactQuestion && this.mobileVersion
            ? "15px 0!important"
            : "",
        minHeight: "78vh!important",
        backgroundColor: this.isContactQuestion ? "#361c5d" : ""
      };
    },
    isContactQuestion() {
      return (
        this.quiz.questions[this.selectedQuestion]?.type === "contacts" &&
        this.mobileVersion
      );
    },
    onlyQuestion() {
      return (
        this.selectedQuestion < this.quiz.questions.length - 2 &&
        this.selectedQuestion !== -1
      );
    },
    styleMainBlockLeftPart(): CSSProperties {
      return {
        backgroundColor:
          this.currentQuestion.type === "contacts" && this.mobileVersion
            ? "white"
            : "",
        borderRadius: this.isContactQuestion ? "15px 15px 0 0" : "",
        flexDirection: this.mobileVersion ? "column" : "column-reverse"
      };
    }
  }
});
</script>
